<template>
    <div class="how-it-works-area how-it-works-bg section-space--pb_120">
        <div class="container-fluid container-fluid--cp-150">
            <div class="row align-items-center">
                <div class="col-lg-7 video-popup video-link section-space--pb_120 order-1">
                        <div class="single-popup-wrap">
                            <iframe width="100%" height="500" src="https://www.youtube.com/embed/3FDzGTZeVso" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                </div>
                <div class="col-lg-5 mt-3 mt-lg-0 section-space--pb_120 order-2">
                    <div class="how-it-works__content margin-center text-left">
                        <h3 class="section-title font-weight--light mb-15 wow move-up">Perchè Bacco Lab</h3>
                        <ul class="check-list green-check-list section-space--mb_50 wow move-up">
                            <li class="list-item">Una start-up innovativa, fatta di giovani talenti del settore che guardano al futuro. </li>
                            <li class="list-item">Un software in linea con le prossime sfide del futuro! GREEN - SOSTENIBILITÀ - TRACCIABILITÀ</li>
                            <li class="list-item"><router-link :to="{path: '/', hash: '#contact'}">Che aspetti? Non farti scappare questa occasione, prenota subito una demo! </router-link></li>
                        </ul>
                        <h6 class="sub-heading wow move-up">{{ $t("message.weCanHelpYou") }} <a href="#contact" class="hover-style-link hover-style-link--green">{{ $t("message.writeUs") }}</a></h6>
                    </div>
                </div>
                <div class="col-lg-7 order-3 order-lg-4 video-popup video-link section-space--pb_120">
                        <div class="single-popup-wrap">
                            <iframe width="100%" height="500" src="https://www.youtube.com/embed/0hLfxnmJi1g" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                </div>
                <div class="col-lg-5 order-4 order-lg-3 mt-3 mt-lg-0 section-space--pb_120">
                    <div class="how-it-works__content margin-center text-left">
                        <h3 class="section-title font-weight--light mb-15 wow move-up">La Cantina 2.0</h3>
                        <ul class="check-list green-check-list section-space--mb_50 wow move-up">
                            <li class="list-item">Le migliori tecnologie di sviluppo software a tua disposizione. </li>
                            <li class="list-item">Elevate prestazioni, personalizzazione totale</li>
                            <li class="list-item">Un software nato seguendo le vostre esigenze, per risolvere i vostri problemi </li>
                        </ul>
                        <h6 class="sub-heading wow move-up">{{ $t("message.weCanHelpYou") }} <a href="#contact" class="hover-style-link hover-style-link--green">{{ $t("message.writeUs") }}</a></h6>
                    </div>
                </div>
                <div class="col-lg-7 order-5 video-popup video-link">
                        <div class="single-popup-wrap text-center">
                            <iframe class="margin-center" width="423" height="752" src="https://www.youtube.com/embed/RHaCoidqfMc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                </div>
                <div class="col-lg-5 mt-3 mt-lg-0 order-6">
                    <div class="how-it-works__content margin-center text-left">
                        <h3 class="section-title font-weight--light mb-15 wow move-up">Multi Piattaforma</h3>
                        <ul class="check-list green-check-list section-space--mb_50 wow move-up">
                            <li class="list-item">Bacco Lab ti segue qualsiasi strumenti usi. </li>
                            <li class="list-item">Smartphone, Tablet o PC, ovunque vada potrai sfruttare appieno le funzionalità di BaccoLab</li>
                            <li class="list-item">Integrazione totale tra smartphone e portale per poter lavorare al meglio tra i diversi operatori della cantina.</li>
                        </ul>
                        <h6 class="sub-heading wow move-up">{{ $t("message.weCanHelpYou") }} <a href="#contact" class="hover-style-link hover-style-link--green">{{ $t("message.writeUs") }}</a></h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FeatureAgency',
    };
</script>